import Fuse from 'fuse.js';
import { isArray } from 'lodash';

const SEARCH_TYPES = {
    fuzzy: 'fuzzy',
    exact: 'exact'
}

const fuzzySearch = (data, filter, keys) => {
    const fuse = new Fuse(data, {
        keys: keys.length > 0 ? keys : keys(data[0]),
        includeScore: true,
        includeMatches: true,
        threshold: 0.6
    });

    const result = fuse.search(filter);
    return result.map(({ item }) => item)
}

const exactSearch = (data, filter, keys) => {

    return data.filter(item => {
        return keys.some(key => {
            let value;
            if (key.includes('.')) {
                value = key.split('.').reduce((obj, k) => {
                    // Check if item[obj][k] is null
                    if (item[obj] === null || item[obj][k] === null) {
                        return ''
                    }
                    // Check if the object is an array
                    const isArray = Array.isArray(item[obj])
                    if (isArray) {
                        return item[obj].map(o => o[k])[0]
                    }

                    return item[obj][k]
                });
            } else {
                value = item[key]
            }

            if (isArray(value)) {
                // Normalize array values
                const formattedValue = value.map(v => v.normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toLowerCase()).join(' ');
                const formattedFilter = filter.normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toLowerCase();
                return formattedValue.includes(formattedFilter);
            }

            if (value && typeof value === 'string') {
                const formattedValue = value.normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toLowerCase();
                const formattedFilter = filter.normalize('NFD').replace(/\p{Diacritic}/gu, '').trim().toLowerCase();
                return formattedValue.includes(formattedFilter);
            }
            if (typeof value === 'number') {
                return parseInt(value) === Number(filter)
            }
            return false;
        });
    });
};



export const searchUtils = {
    SEARCH_TYPES,
    fuzzySearch,
    exactSearch
}
